import { api } from '@/lib/api'

/**
 * @returns {Promise<import('@/types/api').AdminRole[]>}
 */
export async function fetchRoles() {
  const { data } = await api.get('/admin/roles')
  return data.data.roles
}

/**
 * @returns {Promise<Array<{ id: number, slug: string, name: string, group: string }>>}
 */
export async function fetchAssignablePermissions() {
  const { data } = await api.get('/admin/permissions')
  return data.data.permissions
}

/**
 * @param {{ name: string, description?: string | null, permission_ids: number[] }} payload
 */
export async function createRole(payload) {
  const { data } = await api.post('/admin/roles', payload)
  return data.data.role
}

/**
 * @param {number} roleId
 * @param {{ name?: string, description?: string | null, permission_ids?: number[] }} payload
 */
export async function updateRole(roleId, payload) {
  const { data } = await api.put(`/admin/roles/${roleId}`, payload)
  return data.data.role
}

/**
 * @param {number} roleId
 */
export async function deleteRole(roleId) {
  await api.delete(`/admin/roles/${roleId}`)
}
